/*
  Easy Bundle SDK 1-466 emits gbb-add-bundle-to-cart:success on document after a
  successful add and discount handling, with detail.offerId. Its full-page renderer
  changes the mount's class but preserves data-offer-id. Do not watch selections:
  those are the provider's draft bundle, not the Shopify cart.
*/
(() => {
  if (customElements.get('maison-apps')) return;

  customElements.define('maison-apps', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      if (this.dataset.renderApp !== 'true') return;
      this.controller = new AbortController();

      document.addEventListener('gbb-add-bundle-to-cart:success', (event) => {
        const offerId = event.detail?.offerId;
        if (typeof offerId !== 'string' || !offerId) return;
        const ownsOffer = Array.from(this.querySelectorAll('[data-offer-id]'))
          .some((mount) => mount.dataset.offerId === offerId);
        if (!ownsOffer) return;

        // Impact fetches the current cart, updates cart-count and re-renders the
        // drawer on this event. A raw cart:change without section HTML would break
        // its drawer listener. No synthetic add event or premature drawer opening.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        const success = this.querySelector('[data-app-success]');
        const announcement = this.querySelector('[data-app-announcement]');
        const message = this.querySelector('[data-app-success-message]');
        if (success) success.hidden = false;
        if (announcement && message) announcement.replaceChildren(message.content.cloneNode(true));
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
